// extracted by mini-css-extract-plugin
export default {"serviceCard":"ServiceCard_serviceCard__sSOoJ","titleContainer":"ServiceCard_titleContainer__pu6PS","tagContainer":"ServiceCard_tagContainer__E1h9n"};